import { datadogRum } from '@datadog/browser-rum-slim';
import { useRouter } from 'next/router';
import { useEffect } from 'react';

const { version } = require('../../../../package.json');

// The previous state keeps the latest options for the event,
// so we can filter duplicates that can be caused by React Strict mode.
// For the same reason, it's a singleton, and we didn't implement as useRef.
let prevState: { service: string; pathname: string } | null = null;

export const useDataDogStartView = (service: string) => {
  const { pathname } = useRouter();

  useEffect(() => {
    if (!(prevState && prevState.service === service && prevState.pathname === pathname)) {
      prevState = { service, pathname };

      datadogRum.startView({
        name: pathname,
        service,
        version
      });
    }
  }, [pathname, service]);
};
